// Layout.js
import Button from 'components/Button';
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { logout } from 'slice/userSlice';
import { useDispatch } from 'react-redux';
import { IoPersonCircleSharp } from "react-icons/io5";
import { FaSlidersH, FaMoneyBillWave, FaIdCard, FaHandHoldingUsd, FaTags, FaUsers } from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import logo from '../asserts/img/logo.png';
import { toast } from 'react-toastify'
import { io } from "socket.io-client";
import { useLocation } from 'react-router-dom';

const socket = io(process.env.REACT_APP_BACKEND)
// const currentUrl = window.location.pathname;
// const lastSegment = currentUrl.substring(currentUrl.lastIndexOf('/') + 1);

const Layout = ({ children }) => {
    const [toggled, setToggle] = useState(window.innerWidth < 768);
    const [openMenu, setOpenMenu] = useState(null);
    const dispatch = useDispatch();
    const nevigate = useNavigate();
    const userRole = localStorage.getItem('role') || 'superAdmin';

    const { pathname } = useLocation();
    const lastSegment = pathname.split('/').pop();

    const protectedTabs = {
        dashboard: process.env.REACT_APP_DASHBOARD_PASSWORD,
        category: process.env.REACT_APP_DASHBOARD_PASSWORD,
        qrcode: process.env.REACT_APP_DASHBOARD_PASSWORD,
        banner: process.env.REACT_APP_DASHBOARD_PASSWORD,
        products: process.env.REACT_APP_DASHBOARD_PASSWORD,
        service: process.env.REACT_APP_DASHBOARD_PASSWORD,
        adminUser: process.env.REACT_APP_DASHBOARD_PASSWORD,
    };

    const closeMenu = () => {
        setOpenMenu(null);
        if (window.innerWidth < 768) {
            setToggle(true);
        }
    };




    const [passwordInput, setPasswordInput] = useState("");
    const [passwordModalOpen, setPasswordModalOpen] = useState(false);
    const [currentProtectedTab, setCurrentProtectedTab] = useState(null);
    const [unlockedTabs, setUnlockedTabs] = useState({});



    const [notifications, setNotifications] = useState([]);
    // const [newBid, setNewBid] = useState([]);

    const audioRef = useRef(null);

    const handleTabClick = (tabName) => {
        if (window.innerWidth < 768) {
            setToggle(true);
        }
        if (protectedTabs[tabName]) {
            if (unlockedTabs[tabName]) {
                if (tabName === 'dashboard') {
                    nevigate('/dashboard');
                } else {
                    toggleMenu(tabName);
                }
            } else {
                setCurrentProtectedTab(tabName);
                setPasswordModalOpen(true);
            }
        } else {
            if (tabName === 'dashboard') {
                nevigate('/dashboard');
            } else {
                toggleMenu(tabName);
            }
        }
    };


    const verifyTabPassword = () => {
        if (passwordInput === protectedTabs[currentProtectedTab]) {
            toast.success("Access Granted!");

            setUnlockedTabs({
                ...unlockedTabs,
                [currentProtectedTab]: true,
            });

            setPasswordModalOpen(false);
            setPasswordInput("");

            if (currentProtectedTab === "dashboard") {
                nevigate("/dashboard");
            } else {
                toggleMenu(currentProtectedTab);
            }

            // toggleMenu(currentProtectedTab);
        } else {
            toast.error("Wrong Password!");
        }
    };




    useEffect(() => {
        socket.on("new-payment", (data) => {
            setNotifications([...notifications, data]);

            // Play notification sound
            toast('New Order Added')
            if (audioRef.current) {
                audioRef.current.play().catch(error =>
                    console.error("Error playing sound:", error)
                );
            }
        });

        return () => {
            socket.off("new-payment");
            setNotifications([]);
        };
    }, []);

    // useEffect(() => {
    //     socket.on("new-bid", (data) => {
    //         setNewBid([...notifications, data]);
    //         // Play notification sound
    //         toast('New Bid Added')
    //         if (audioRef.current) {
    //             audioRef.current.play().catch(error =>
    //                 console.error("Error playing sound:", error)
    //             );
    //         }
    //     });

    //     return () => {
    //         socket.off("new-bid");
    //         setNewBid([]);
    //     };
    // }, []);

    useEffect(() => {
        socket.on("new-withdrawal", (data) => {
            setNotifications([...notifications, data]);
            // Play notification sound
            toast('New Withdrawal Added')
            if (audioRef.current) {
                audioRef.current.play().catch(error =>
                    console.error("Error playing sound:", error)
                );
            }
        });

        return () => {
            socket.off("new-withdrawal");
            setNotifications([]);
        };
    }, []);

    // Window resize listener for responsive sidebar
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setToggle(true);
            } else {
                setToggle(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleMenu = (menu) => {
        setOpenMenu(openMenu === menu ? null : menu);
    };

    const logoutHandler = async (e) => {
        e.preventDefault();
        try {
            dispatch(logout());
            nevigate('/signin');
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <>
            <div id="wrapper">
                <audio ref={audioRef} src="https://assets.mixkit.co/active_storage/sfx/933/933-preview.mp3" autoPlay >
                    <track kind="captions" src="" default />
                </audio>
                <ul className={toggled ? 'navbar-nav sidebar sidebar-dark toggled shadow-lg' : 'navbar-nav sidebar sidebar-dark accordion shadow-lg'} id="accordionSidebar" style={{ background: 'linear-gradient(180deg, #0EA5A4 0%, #082032 100%)', transition: 'all 0.3s', height: '100vh', overflowY: 'auto', position: 'sticky', top: 0, zIndex: 1000 }}>
                    <div className="text-center d-flex align-items-center justify-content-center" style={{ borderBottom: '1px solid rgba(255,255,255,0.1)', padding: '30px 10px 10px 10px' }}>
                        <img src={logo} alt='adminlogo' className='img-fluid adminlogo' style={{ maxWidth: '100%', width: '180px', transform: 'scale(1.5)', transformOrigin: 'center' }} />
                    </div>

                    <li className={`nav-item mt-2 ${lastSegment === 'dashboard' ? 'active bg-info rounded mx-2' : ''}`}>
                        <Link className="nav-link text-white font-weight-bold" to="#" onClick={(e) => { e.preventDefault(); handleTabClick("dashboard"); }}>
                            <MdDashboard className='mr-2' size={20} />
                            <span>Dashboard</span>
                        </Link>
                    </li>

                    <hr className="sidebar-divider my-2" style={{ borderColor: 'rgba(255,255,255,0.2)' }} />

                    <div className="sidebar-heading text-white-50 mt-2 mb-1" style={{ fontSize: '0.75rem', textTransform: 'uppercase', padding: '0 15px', letterSpacing: '1px' }}>
                        Loan System
                    </div>

                    <li className="nav-item">
                        <Link className="nav-link text-white" to="#" onClick={(e) => { e.preventDefault(); toggleMenu('loanUser'); }}>
                            <FaIdCard className='mr-2' size={18} />
                            <span>Loan User</span>
                        </Link>
                        {openMenu === 'loanUser' && (
                            <div className="bg-white py-2 rounded mx-2 my-1 shadow-sm">
                                <Link className="d-block px-3 py-2" to="/users/add" onClick={closeMenu} style={{ textDecoration: 'none' }}>
                                    <span style={{ color: '#007BFF', fontWeight: 'bold', fontSize: '15px' }}>Add User</span>
                                </Link>
                                <Link className="d-block px-3 py-2" to="/kyc-users" onClick={closeMenu} style={{ textDecoration: 'none' }}>
                                    <span style={{ color: '#007BFF', fontWeight: 'bold', fontSize: '15px' }}>User List</span>
                                </Link>
                            </div>
                        )}
                    </li>

                    <li className="nav-item">
                        <Link className="nav-link text-white" to="/manage-loans" onClick={closeMenu}>
                            <FaHandHoldingUsd className='mr-2' size={18} />
                            <span>Manage Loans</span>
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link className="nav-link text-white" to="/emi-wallet" onClick={closeMenu}>
                            <FaMoneyBillWave className='mr-2' size={18} />
                            <span>EMI collection list </span>
                        </Link>
                    </li>

                    <li className="nav-item">
                        <Link className="nav-link text-white" to="/manage-categories" onClick={closeMenu}>
                            <FaTags className='mr-2' size={18} />
                            <span>Manage Categories</span>
                        </Link>
                    </li>

                    {userRole === 'superAdmin' && (
                        <li className="nav-item">
                            <Link className="nav-link text-white" to="#" onClick={(e) => { e.preventDefault(); toggleMenu('loanProviders'); }}>
                                <FaUsers className='mr-2' size={18} />
                                <span>Loan Providers</span>
                            </Link>
                            {openMenu === 'loanProviders' && (
                                <div className="bg-white py-2 rounded mx-2 my-1 shadow-sm">
                                    <Link className="d-block px-3 py-2" to="/loan-providers/add" onClick={closeMenu} style={{ textDecoration: 'none' }}>
                                        <span style={{ color: '#007BFF', fontWeight: 'bold', fontSize: '15px' }}>Add Provider</span>
                                    </Link>
                                    <Link className="d-block px-3 py-2" to="/loan-providers" onClick={closeMenu} style={{ textDecoration: 'none' }}>
                                        <span style={{ color: '#007BFF', fontWeight: 'bold', fontSize: '15px' }}>Provider List</span>
                                    </Link>
                                </div>
                            )}
                        </li>
                    )}

                    {userRole === 'superAdmin' && (
                        <li className="nav-item">
                            <Link className="nav-link text-white" to="#" onClick={(e) => { e.preventDefault(); toggleMenu('banner'); }}>
                                <FaTags className='mr-2' size={18} />
                                <span>Manage Banners</span>
                            </Link>
                            {openMenu === 'banner' && (
                                <div className="bg-white py-2 rounded mx-2 my-1 shadow-sm">
                                    <Link className="d-block px-3 py-2" to="/banner/add" onClick={closeMenu} style={{ textDecoration: 'none' }}>
                                        <span style={{ color: '#007BFF', fontWeight: 'bold', fontSize: '15px' }}>Add Banner</span>
                                    </Link>
                                    <Link className="d-block px-3 py-2" to="/banner" onClick={closeMenu} style={{ textDecoration: 'none' }}>
                                        <span style={{ color: '#007BFF', fontWeight: 'bold', fontSize: '15px' }}>Banner List</span>
                                    </Link>
                                </div>
                            )}
                        </li>
                    )}

                    {/* Extra unused modules hidden per request */}
                    
                    <div className="text-center d-none d-md-inline mt-4 mb-4">
                        <button className="rounded-circle border-0 bg-light text-primary p-2" id="sidebarToggle" onClick={() => setToggle(!toggled)}>
                           <FaSlidersH />
                        </button>
                    </div>
                </ul>

                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <nav className="navbar navbar-expand navbar-dark topbar mb-4 static-top shadow" style={{ background: 'linear-gradient(90deg, #082032 0%, #0EA5A4 100%)' }}>
                            <button id="sidebarToggleTop" onClick={() => setToggle(!toggled)} className="btn btn-link d-md-none rounded-circle mr-3">
                                <i className="fa fa-bars"></i>
                            </button>
                            <ul className="navbar-nav ml-auto">
                                {/* <div className="topbar-divider d-none d-sm-block"></div> */}
                                <li className="nav-item dropdown no-arrow">
                                    <Link className="nav-link dropdown-toggle" href="#" id="userDropdown" role="button"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <span className="mr-2 d-none d-lg-inline text-white font-weight-bold small">
                                            {userRole === 'loanProvider' ? 'Loan Provider' : 'Admin'}
                                        </span>
                                        <IoPersonCircleSharp size={24} style={{ color: "#ffffff" }} />
                                    </Link>
                                    <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                                        aria-labelledby="userDropdown">
                                        <div className="dropdown-divider"></div>
                                        <Button className="dropdown-item" text='Logout' onclickfun={logoutHandler} />
                                        <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
                                    </div>
                                </li>
                            </ul>
                        </nav>
                        {children}
                    </div>
                </div>
            </div>
            {passwordModalOpen && (
                <div className="modal-backdrop show" style={{ zIndex: 9999 }}>
                    <div className="modal d-block" tabIndex="-1">
                        <div className="modal-dialog modal-sm modal-dialog-centered">
                            <div className="modal-content p-3">
                                <h5 className="text-center">Enter Password</h5>
                                <input
                                    type="password"
                                    className="form-control mt-2"
                                    placeholder="Enter password"
                                    value={passwordInput}
                                    onChange={(e) => setPasswordInput(e.target.value)}
                                />
                                <button className="btn btn-primary btn-block mt-3" onClick={verifyTabPassword}>
                                    Unlock
                                </button>
                                <button className="btn btn-light btn-block mt-2" onClick={() => setPasswordModalOpen(false)}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


        </>
    );
};

export default Layout;

